import React from 'react';
import ApprovalHistory from '../approval/ApprovalHistory';

// Repair-flavoured binding of the shared approval history table.
const RepairApprovalHistory = ({ repairId }) => (
  <ApprovalHistory
    resourcePath="repairs"
    itemId={repairId}
    emptyMessage="No approval activity yet — this repair is still a draft."
  />
);

export default RepairApprovalHistory;
